import React from 'react'
import Skeleton from 'react-loading-skeleton'

const PaymentCardSkeleton = () => {
  return <Skeleton width={'100%'} height={49} />
}

export default PaymentCardSkeleton
